<script setup lang="ts">
import { readItems } from '@directus/sdk'
defineI18nRoute({
  paths: {
    en: '/about-us',
    fr: '/a-propos',
    nl: '/over-ons',
  },
})

definePageMeta({
  auth: false,
})

const { request } = useDirectusRest()

const { locale } = useI18n()

const { data: blocks, refresh } = await useAsyncData(
  `about-blocks-${locale.value}`,
  () =>
    request(
      readItems('page', {
        deep: {
          blocks: {
            item: {
              translations: {
                _filter: {
                  languages_code: {
                    _eq: locale.value,
                  },
                },
              },
            },
          },
        },
        fields: [
          {
            blocks: ['collection', { item: ['*', { translations: ['*'] }] }],
          },
        ],
        filter: {
          name: 'about',
        },
      }),
    ),
  {
    transform: (res) => {
      return res[0].blocks.map((block) => {
        return {
          ...block.item,
          component: block.collection,
          translations: block.item.translations.filter((translation) => {
            return translation.languages_code == locale.value
          }),
        }
      })
    },
    watch: [locale],
  },
)
</script>

<template>
  <div class="mx-auto w-full max-w-5xl space-y-4 px-5 lg:px-0">
    
    <component
      :data="block"
      :is="block.component"
      :key="`block-about-${block.id}`"
      v-for="block in blocks"
    />
  </div>
</template>
